/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-25 09:52:35
 * @Explain: redux 类型声明
 */
import type { ActivityAbTestState } from './activityAbTest';
import type { activityCycleState } from './activityCycle';
import type { ActivityState } from './activityManage';
import type { ActivityReportState } from './activityReport';
import type { ActivityWhatsAppState } from './activityWhatsApp';
import type { BusinessControlConfigState } from './businessControlConfig';
import type { CommonState } from './common';
import type { ContactAttributesState } from './contactAttributes';
import type { ContactManageState } from './contactManage';
import type { ContactReportState } from './contactReport';
import type { ContactSignUpFormState } from './contactSignUpForm';
import type { EmailConfigState } from './emailConfig';
import type { HomeState } from './home';
import type { LabelManageState } from './labelManage';
import type { NewsletterState } from './newsletter';
import type { PlaceholderManageState } from './placeholderManage';
import type { SegmentsManageState } from './segmentsManage';
import type { TemplateState } from './templateManage';
import type { TesterState } from './testerManage';
import type { UserJourneyModelStateType } from './userJourney';
export interface ConnectState {
  CommonModel: CommonState;
  HomeModel: HomeState;
  ActivityAbTestModel: ActivityAbTestState;
  ActivityCycleModel: activityCycleState;
  ActivityModel: ActivityState;
  ActivityWhatsAppModel: ActivityWhatsAppState;
  ContactAttributesModel: ContactAttributesState;
  ContactReportModel: ContactReportState;
  ContactManageModel: ContactManageState;
  ContactSignUpFormModel: ContactSignUpFormState;
  SegmentsManageModel: SegmentsManageState;
  TemplateModel: TemplateState;
  EmailConfigModel: EmailConfigState;
  ActivityReportModel: ActivityReportState;
  LabelManageModel: LabelManageState;
  NewsletterModel: NewsletterState;
  PlaceholderManageModel: PlaceholderManageState;
  BusinessControlConfigModel: BusinessControlConfigState;
  TesterModel: TesterState;
  UserJourneyModel: UserJourneyModelStateType;
}

export interface ConnectAction {
  readonly type: string;
  payload: any;
}

export enum ReducersEnum {
  /** common */
  /* 设置区域管理-是否展开列表 */
  SET_AREA_MANAGE_EXPANDED_GROUPS = 'CommonModel/setAreaManageExpandedGroups',
  // aegis 上报
  SET_AEGIS = 'CommonModel/setAegis',
  // 语言
  SET_LOCAL_LANGUAGE = 'CommonModel/setLocalLanguage',
  // 当前时区
  SET_TIME_ZONE = 'CommonModel/setTimezone',

  // 设置是否重新加载接口判断
  SET_RELOAD_INTERFACE_FLAG = 'CommonModel/setReloadInterFaceFlag',

  // 是否登录
  GET_IS_LOGIN = 'CommonModel/getIsLogin',
  // 设置登录状态
  SET_LOGIN_STATUS = 'CommonModel/setLoginStatus',
  // 设置登录类型
  SET_LOGIN_TYPE = 'CommonModel/setLoginType',
  // 退出登录
  ON_LOG_OUT = 'CommonModel/onLogOut',
  // 设置token
  SET_TOKEN = 'CommonModel/setToken',

  // 用户信息
  GET_USER_INFO = 'CommonModel/getUserInfo',
  SET_USER_INFO = 'CommonModel/setUserInfo',
  // 被邀请申请项目信息
  SET_PROJECT_APPLY_INFO = 'CommonModel/setProjectApplyInfo',
  // 重置被邀请申请项目信息
  RESET_PROJECT_APPLY_INFO = 'CommonModel/resetProjectApplyInfo',
  // 设置是否获取用户状态
  SET_IS_GET_USER_STATUS = 'CommonModel/setIsGetUserStatus',
  // 用户角色
  GET_ROLES = 'CommonModel/getRoles',
  SET_ROLES = 'CommonModel/setRoles',
  // 业务信息
  SET_BUSINESS_LIST = 'CommonModel/setBusinessList',
  SET_CURRENT_BUSINESS = 'CommonModel/setCurrentBusiness',
  // GET_DEMO_PROJECT_INFO = 'CommonModel/getDemoProjectInfo',
  SET_DEMO_PROJECT_INFO = 'CommonModel/setDemoProjectInfo',
  ON_SWITCH_ITEM = 'CommonModel/onSwitchItem',
  // 获取业务级别控制配置信息
  GET_BUSINESS_CONTROL_CONFIG = 'BusinessControlConfigModel/getBusinessControlConfig',
  // 更新业务级别控制配置信息
  SET_BUSINESS_CONTROL_CONFIG = 'BusinessControlConfigModel/setBusinessControlConfig',

  // 设置左侧菜单
  SET_LEFT_MENU_LIST = 'CommonModel/setLeftMenuList',
  // 设置左侧菜单Lock
  SET_LEFT_MENU_LOCK = 'CommonModel/setLeftMenuLock',
  // 设置左侧菜单Collapse
  SET_LEFT_MENU_COLLAPSE = 'CommonModel/setLeftMenuCollapse',
  // 顶部菜单栏 - 是否展示
  SET_IS_FIXED_TOP_HEADER = 'CommonModel/setIsFixedTopHeader',

  // 国家、语言、时区
  GET_CTL_CONFIG = 'CommonModel/getCTLConfig',
  SET_TIMEZONE_LIST = 'CommonModel/setTimezoneList',
  SET_COUNTRY_LIST = 'CommonModel/setCountryList',
  SET_LANGUAGE_LIST = 'CommonModel/setLanguageList',

  // 设置当前项目下首个用户加入的时间
  SET_GAME_FIRST_USER_INFO = 'CommonModel/setGameFirstUserInfo',

  // 记录列表筛选
  SET_FILTER_LIST = 'CommonModel/setFilterList',
  SET_FILTER_ITEM = 'CommonModel/setFilterItem',
  RESET_FILTER_LIST = 'CommonModel/resetFilterList',
  RESET_ONE_FILTER = 'CommonModel/resetOneFilter',
  // 监听主路由信息发生变化，初始化临时存储的筛选信息
  SET_TEMPORARY_FILTER_ITEM = 'CommonModel/setTemporaryFilterItem',

  // layout
  SET_IS_LAYOUT_BODY_STYLE = 'CommonModel/setIsLayoutBodyStyle',

  /** 获取需要设置的配置 */
  GET_CONFIG_TO_BE_SET = 'CommonModel/getConfigToBeSet',
  /** 设置需要设置的配置 */
  SET_CONFIG_TO_BE_SET = 'CommonModel/setConfigToBeSet',
  /** 是否重新加载获取需要的配置 */
  SET_IS_CONFIG_TO_BE_SET = 'CommonModel/setIsConfigToBeSet',
  /** 设置否展示常规公告 * */
  SET_IS_SHOW_FIRST_TIME_ANNOUNCEMENT = 'CommonModel/setIsShowFirstTimeAnnouncement',

  /** 更新跳转创建模板时用于回跳后回显内容记录 */
  SET_SAVED_MAIL_TEMPLATE = 'CommonModel/setSavedMailTemplate',
  /** 重置跳转创建模板时用于回跳后回显内容记录 */
  RESET_SAVED_MAIL_TEMPLATE = 'CommonModel/resetSavedMailTemplate',

  /** Home todolist用户状态相关信息 */
  SET_HOME_TODO_STATUS_INFO = 'HomeModel/setToDoStatusInfo',
  /** Home 重置todolist用户状态相关信息 */
  SET_HOME_TODO_STATUS_INFO_RESET = 'HomeModel/resetToDoStatusInfo',

  /** 活动 - activityMange */
  SET_CREATE_CAMPAIGN_OPTIONS = 'ActivityModel/setCreateCampaignOptions',
  SET_IS_INTERCEPT_ROUTE_STATUS = 'ActivityModel/setInterceptRouteStatus',
  SET_TABS_ACTIVE = 'ActivityModel/setTabsActive',
  SET_DRAFT_CACHE = 'ActivityModel/setDraftCache',
  RESET_DRAFT_CACHE = 'ActivityModel/resetDraftCache',

  /** 活动 - 周期 */
  SET_CREATE_ACTIVITY_CYCLE_OPTIONS = 'ActivityCycleModel/setCreateCycleOptions',
  SET_ACTIVITY_CYCLE_IS_INTERCEPT_ROUTE_STATUS = 'ActivityCycleModel/setInterceptRouteStatus',
  SET_ACTIVITY_CYCLE_TABS_ACTIVE = 'ActivityCycleModel/setTabsActive',
  SET_ACTIVITY_CYCLE_DRAFT_CACHE = 'ActivityCycleModel/setDraftCache',
  RESET_ACTIVITY_CYCLE_DRAFT_CACHE = 'ActivityCycleModel/resetDraftCache',

  /** 活动 - AB 测试 */
  SET_CREATE_AB_TEST_OPTIONS = 'ActivityAbTestModel/setCreateAbTestOptions',
  SET_AB_TEST_IS_INTERCEPT_ROUTE_STATUS = 'ActivityAbTestModel/setInterceptRouteStatus',
  SET_AB_TEST_TABS_ACTIVE = 'ActivityAbTestModel/setTabsActive',
  SET_AB_TEST_DRAFT_CACHE = 'ActivityAbTestModel/setDraftCache',
  RESET_AB_TEST_DRAFT_CACHE = 'ActivityAbTestModel/resetDraftCache',

  /** 活动 - WhatsApp */
  SET_CREATE_WHATSAPP_OPTIONS = 'ActivityWhatsAppModel/setCreateWhatsAppOptions',
  SET_WHATSAPP_IS_INTERCEPT_ROUTE_STATUS = 'ActivityWhatsAppModel/setInterceptRouteStatus',
  SET_WHATSAPP_TABS_ACTIVE = 'ActivityWhatsAppModel/setTabsActive',
  SET_WHATSAPP_DRAFT_CACHE = 'ActivityWhatsAppModel/setDraftCache',
  RESET_WHATSAPP_DRAFT_CACHE = 'ActivityWhatsAppModel/resetDraftCache',
  SET_WHATSAPP_TEMPLATE_INFO = 'ActivityWhatsAppModel/setTemplateCache',

  /** 分层 - segmentsManage */
  SET_CREATE_SEGMENT_OPTIONS = 'SegmentsManageModel/setCreateSegmentOptions',
  SET_BUILT_EXPANDED_LIST = 'SegmentsManageModel/setBuiltExpandedList',

  /** 内容 - templateMange */
  SET_MAIL_TEMPLATE_FORM = 'TemplateModel/setMailTemplateForm',
  RESET_MAIL_TEMPLATE_FORM = 'TemplateModel/resetMailTemplateForm',
  // 列表
  SET_MAIL_TEMPLATE_LIST = 'TemplateModel/setMailTemplateList',
  RESET_MAIL_TEMPLATE_LIST = 'TemplateModel/resetMailTemplateList',

  // 列表 trans 类型
  SET_MAIL_TEMPLATE_TRANS_LIST = 'TemplateModel/setMailTemplateTransList',
  RESET_MAIL_TEMPLATE_TRANS_LIST = 'TemplateModel/resetMailTemplateTransList',

  // 保存配置项
  SET_MAIL_TEMPLATE_AUTO_SAVE = 'TemplateModel/setMailTemplateAutoSaveConfig',
  RESET_MAIL_TEMPLATE_AUTO_SAVE = 'TemplateModel/resetMailTemplateAutoSaveConfig',

  SET_MAIL_TEMPLATE_MARKETING_DRAWER = 'TemplateModel/setIsMarketingDrawerOpened',
  SET_MAIL_TEMPLATE_TRANS_DRAWER = 'TemplateModel/setIsTransDrawerOpened',

  /** 设置管理  - settingManage */
  SET_DOMAIN_NAME_LIST = 'EmailConfigModel/setDomainNameList',
  GET_DOMAIN_NAME_LIST = 'EmailConfigModel/getDomainNameList',
  SET_DOMAIN_NAME_LIST_STATUS = 'EmailConfigModel/setDomainNameListStatus',
  SET_NOT_VERIFIED_DOMAIN_LIST = 'EmailConfigModel/setNotVerifiedDomainList',

  /** Report页面动态指标值 */
  SET_DYNAMIC_INDEX_INFO = 'ActivityReportModel/setDynamicIndexInfo',
  SET_REPORT_DETAIL_DATA = 'ActivityReportModel/setReportDetailData',
  /** 活动报表 -  */
  SET_REPORT_DETAIL_DATA = 'ActivityReportModel/setReportDetailData',
  /** 设置报表内计算、显示等依赖信息 */
  SET_DEPEND_ON_INFO = 'ActivityReportModel/setDependOnInfo',
  /** 设置ABtest活动 - 实验数据项 */
  SET_AB_TEST_OPTS = 'ActivityReportModel/setABTestOpts',

  /** 标签管理 - 当前业务是否开启预测标记 & 是否已打通in-game数据 */
  SET_PREDICTIVE_TAGS_INFO = 'LabelManageModel/setPredictiveTagsInfo',
  /** 预测页面 - 设置 提示信息展开状态 */
  SET_PREDICTIVE_TAGS_SET_ALERT = 'LabelManageModel/setPredictiveAlert',
  /** 预测页面 - 重置 提示信息展开状态 */
  SET_PREDICTIVE_TAGS_RESET_ALERT = 'LabelManageModel/resetPredictiveAlert',

  // 联系人报表
  SET_REGION_OPTIONS = 'ContactReportModel/setRegionOptions',

  // 联系人管理
  /** 创建联系人 - 来源 */
  SET_ADD_CONTECT_SOURCE_TYPE = 'ContactManageModel/setAddContectSourceType',

  // 联系人 - 自定义字段
  SET_ATTRIBUTES_LIST = 'ContactAttributesModel/setAttributesList',

  /** 联系人 - 预约设置信息 */
  SET_NEWSLETTER_DETAILS = 'ContactManageModel/setNewsletterDetails',
  /** 联系人 - 预约设置信息 */
  SET_NEWSLETTER_FORM_DATA = 'NewsletterModel/setNewsletterFormData',

  /** 联系人 - 注册表单 */
  // 联系人 - 注册表单
  SET_C_SIGN_UP_FORM_DATA = 'ContactSignUpFormModel/setSignUpFormData',
  // 联系人 - 注册表单 - 选中文本配置
  SET_C_SIGN_UP_SELECTED_TEXT_CONFIG = 'ContactSignUpFormModel/setSelectedTextConfig',
  // 联系人 - 注册表单 - 设置表单跳转 - 信息缓存
  SET_C_SIGN_UP_SET_FORM_CACHE = 'ContactSignUpFormModel/setFormCache',
  SET_C_SIGN_UP_RESET_FORM_CACHE = 'ContactSignUpFormModel/resetFormCache',
  // 联系人 - 注册表单 - 获取表单需要设置的配置
  SET_C_SIGN_UP_SET_FORM_CONFIG = 'ContactSignUpFormModel/setFormConfig',

  /** 占位符 */
  // 暂停的占位符数据
  SET_PAUSE_PLACEHOLDER_DATA = 'PlaceholderManageModel/setPausePlaceholderData',
  /** 重置暂停占位符数据 */
  RESET_PAUSE_PLACEHOLDER_DATA = 'PlaceholderManageModel/resetPausePlaceholderData',

  /** 测试玩家管理模块 */
  SET_CREATE_TESTER_OPTIONS = 'TesterModel/setCreateTesterOptions',
  SET_TESTER_IS_INTERCEPT_ROUTE_STATUS = 'TesterModel/setInterceptRouteStatus',
  SET_TESTER_TABS_ACTIVE = 'TesterModel/setTabsActive',
  SET_TESTER_DRAFT_CACHE = 'TesterModel/setDraftCache',
  RESET_TESTER_DRAFT_CACHE = 'TesterModel/resetDraftCache',
  SET_TESTER_CREATED_CACHE = 'TesterModel/setCreatedTesterCache',
  SET_TESTER_INIT_FORM_DATA = 'TesterModel/setInitFormData',
  // 用户路程 修改描述状态
  SET_IS_SHOW_DESCRIPTION = 'UserJourneyModel/setIsShowDescription',
  // 用户路程 触发 获取详情
  SET_IS_GET_DETAILS = 'UserJourneyModel/setIsGetDetails',
  // 用户路程 全局存储 节点数据 自定义hooks判断默认文案
  SET_DISPATCH_NODES = 'UserJourneyModel/setDispatchNodes',
  // 用户路程 设置测试链接
  SET_TEST_LINK = 'UserJourneyModel/setTestLink',
  // 用户路程 设置当前选中节点ID
  SET_CURRENT_NODE_ID = 'UserJourneyModel/setCurrentNodeId',
}
